/* esm.sh - applesauce-content@6.0.0/dist/nast/eol-metadata */
function d(){return n=>{for(let e=0;e<n.children.length;e++){let t=n.children[e],a=n.children[e+1];(t.type==="text"&&t.value.endsWith(`
`)||!a||a.type==="text"&&a.value.startsWith(`
`))&&(t.data=t.data||{},t.data.eol=!0)}}}export{d as eolMetadata};
//# sourceMappingURL=eol-metadata.mjs.map